import { Box, Button, Checkbox, Typography } from '@mui/material';
import { Fragment, useState } from 'react';
import { disconnectedModalTexts, paths } from './config/TextMessage';
import { disConnectedModalSx } from './DisconnectedModalSx';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { setIsOpenChangePlan } from 'src/redux/siteAuditReducer';
import { localStorageMethod } from './config/FunctionHelper';
import { siteDetail } from './Scraper';
import { RootState } from 'src/redux/store';

export const DisconnectedModal = ({
  handleCloseDisconnectSiteModal,
  isLocalSeo = false
}) => {
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);
  // Selector to retrieve site ID from the Redux store.
  const siteId = useSelector((state: RootState) => state.siteAudit.siteId) ?? 0;
  let compare = useSelector((state: RootState) => state.siteAudit.compare);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setDoNotShowAgain(isChecked);
    if (isLocalSeo) {
      if (isChecked) {
        localStorageMethod('set', 'do_not_show_local_seo_disconnect', 'true');
      } else {
        localStorageMethod('set', 'do_not_show_local_seo_disconnect', 'false');
      }
    } else {
      if (isChecked) {
        localStorageMethod('set', 'do_not_show_disconnect', 'true');
      } else {
        localStorageMethod('set', 'do_not_show_disconnect', 'false');
      }
    }
  };

  const handleReconnect = async () => {
    handleCloseDisconnectSiteModal();
    navigate(
      isLocalSeo
        ? paths?.squareSpaceConnectUtmLocalSeo
        : paths?.squareSpaceConnectUtm
    );
    if (!isLocalSeo) {
      let siteDetailResponse: any = await siteDetail(
        siteId,
        compare,
        doNotShowAgain
      );
    }
  };

  return (
    <Fragment>
      <Box sx={disConnectedModalSx?.mainBox}>
        <Typography sx={disConnectedModalSx?.desc}>
          {isLocalSeo
            ? disconnectedModalTexts?.descLocal
            : disconnectedModalTexts?.desc}
        </Typography>
        <Typography sx={{ ...disConnectedModalSx?.desc, marginTop: '12px' }}>
          {disconnectedModalTexts?.descNew}
          <span
            onClick={() => {
              handleCloseDisconnectSiteModal();
              dispatch(setIsOpenChangePlan(true));
              navigate(paths?.billing);
            }}
            style={disConnectedModalSx?.span}
          >
            {disconnectedModalTexts?.billing}
          </span>
          {disconnectedModalTexts?.descOne}
        </Typography>
        {/* Checkbox and text */}
        <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
          <Checkbox
            checked={doNotShowAgain}
            onChange={handleCheckboxChange}
            sx={{ padding: '0 8px 0 0' }} // Adjust the spacing around the checkbox
          />
          <Typography sx={disConnectedModalSx?.checkBoxTextSx}>
            {disconnectedModalTexts?.doNotText}
          </Typography>
        </Box>
        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}
        >
          <Button
            onClick={handleReconnect}
            sx={disConnectedModalSx?.btnSx}
            // fullWidth
            variant="contained"
          >
            {disconnectedModalTexts?.btnText}
          </Button>
        </Box>
      </Box>
    </Fragment>
  );
};
